export default __webpack_public_path__ + "static/media/notebook.969ed9f3.png";